import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { NewAddAccountModel } from "@theHescoBlueprint/ApiModels";
import { addAccountNewCustomer as addAccountNewCustomerApi } from "@theHescoBlueprint/Services/CustomAddAccountService";
import { CustomApiHandler } from "@theHescoBlueprint/Store/CustomHandlerCreator";

type customNewAccountParam = {
    addCustomNewAccountParams: NewAddAccountModel;
} & HasOnSuccess &
    HasOnError<string>;

type HandlerType = CustomApiHandler<customNewAccountParam, NewAddAccountModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addAccountNewCustomerApi(props.parameter.addCustomNewAccountParams);
};

// export const DispatchAccountNewCustomer: HandlerType = props => {
//     props.dispatch({
//         type: "Data/AccountNewCustomer/fields",
//     });
// };

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};
export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    // DispatchAccountNewCustomer,
    ExecuteOnSuccessCallback,
];
const customNewAccount = createHandlerChainRunner(chain, "addAccountNewCustomer");
export default customNewAccount;
